import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import shared from "./shared";
const NoStyles = styled.ul.withConfig({
  componentId: "sc-1dl6zik-0"
})(["", ";& li{list-style:none;}"], shared);

const Unstyled = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(NoStyles, props, children);
};

Unstyled.propTypes = {
  /** List items */
  children: PropTypes.node.isRequired
};
export default Unstyled;